/*!--------------------------------------------------------------------------
// <copyright file="Survey.core.ts" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
var Survey;
(function (Survey) {
    var core;
    (function (core) {
        core.id = {
            timeoutHolder: null
        };
        core.attributeValues = {
            nextGroupButton: 'nextGroupButton',
            nextGroupSubmit: 'nextGroupSubmit',
            previousGroupButton: 'previousGroupButton',
            previousGroupSubmit: 'previousGroupSubmit',
            surveyGroupForm: 'surveyGroupForm',
            timeExpired: 'TimeExpired',
            EnableButtonDelay: 'EnableButtonDelay',
        };
        function nextGroup(e) {
            // <summary>Perform ajax post action.</summary>
            // <param name="e">The current event.</param>
            // Clear the timeout
            if (core.id.timeoutHolder) {
                clearTimeout(core.id.timeoutHolder);
            }
            // Trigger the form post.
            var _input = $("<input>").attr("type", "hidden").attr("name", "action:Next");
            $('#surveyGroupForm').append(_input).trigger("submit");
            return false;
        }
        core.nextGroup = nextGroup;
        function onPageLoad() {
            // <summary>Show the survey group form and enable it on page load.</summary>
            // <summary>This helps ensure javascript functionality is enabled in the browser.</summary>
            $('#' + core.attributeValues.surveyGroupForm).show().prop('disabled', false);
            var _enableButtonDelay = $('#' + core.attributeValues.EnableButtonDelay).val();
            if (_enableButtonDelay && _enableButtonDelay == "True") {
                setTimeout(function () {
                    $(document).on('click', '#' + core.attributeValues.nextGroupButton, core.nextGroup);
                }, 2000);
                $(document).on('click', '#' + core.attributeValues.previousGroupButton, core.previousGroup);
            }
            else {
                $(document).on('click', '#' + core.attributeValues.nextGroupButton, core.nextGroup);
                $(document).on('click', '#' + core.attributeValues.previousGroupButton, core.previousGroup);
            }
            // The following loop is currently only used for Multiple Response and Radio Button questions.
            var groups = Array.prototype.slice.call(document.querySelectorAll('.c-questiongroup'), 0);
            groups.forEach(function (group) {
                // Adds an event listener for enabling/disabling an 'Other' textbox based on whether the corresponding checkbox is selected.
                var requiresInput = Array.prototype.slice.call(group.querySelectorAll('input[data-requires-input]'));
                requiresInput.forEach(function (el) {
                    var other = document.querySelector("#" + el.getAttribute('data-requires-input'));
                    other.addEventListener('keydown', function (e) {
                        if (e.key === "Enter") {
                            e.preventDefault();
                        }
                    });
                    el.addEventListener("change", function (e) {
                        if (el.checked) {
                            other.removeAttribute("disabled");
                            other.classList.remove('is-reset');
                        }
                        else {
                            if (other.value) {
                                other.setAttribute("disabled", "");
                                other.classList.add('is-reset');
                            }
                        }
                    });
                    if (el.type === "radio") {
                        Array
                            .prototype
                            .forEach
                            .call(group.querySelectorAll('input[type="radio"]'), function (r) {
                            r.addEventListener("change", function (e) {
                                if (el.checked) {
                                    other.removeAttribute("disabled");
                                    other.classList.remove('is-reset');
                                }
                                else {
                                    if (other.value) {
                                        other.setAttribute("disabled", "");
                                        other.classList.add('is-reset');
                                    }
                                }
                            });
                        });
                    }
                });
                // Adds an event listener for setting an 'Other' checkbox to selected if a value for the corresponding textbox is entered.
                var extraInputs = Array.prototype.slice.call(group.querySelectorAll('.c-checkbox__extra input, .c-radio__extra input'), 0);
                // When we type into an extra input field, check the associated checkbox or radio button
                extraInputs.forEach(function (el) {
                    el.addEventListener("input", function (e) {
                        if (!!el.value) {
                            var parentInputId = el.getAttribute("data-parent-input");
                            var selector = '[id="' + parentInputId + '"]';
                            var parentInputList = Array.prototype.slice.call(document.querySelectorAll(selector));
                            if (parentInputList.length > 0) {
                                var parentInput = parentInputList[0];
                                parentInput.checked = true;
                            }
                        }
                    });
                });
                // Adds an event listener for enabling/disabling answer options based on whether the 'Don't Know' option is selected.
                var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"], .c-checkbox__extra input'), 0);
                var solo = Array.prototype.slice.call(group.querySelectorAll('[data-checkbox-solo]'));
                // If a checkbox is marked as solo, disabled all other group inputs
                solo.forEach(function (el) {
                    el.addEventListener("click", function (e) {
                        var others = inputs.filter(function (x) {
                            // dont do anything to extra inputs when they have value but their parent is unchecked
                            // as the disabled status is managed on the parent checkbox
                            var matches = x.matches ? x.matches('.c-checkbox__extra input') : x.msMatchesSelector('.c-checkbox__extra input');
                            if (matches) {
                                var parentList = Array.prototype.slice.call(document.querySelectorAll('[data-requires-input="' + x.id + '"]'));
                                if (parentList.length > 0) {
                                    var parent_1 = parentList[0];
                                    if (x.value && parent_1 && !parent_1.checked) {
                                        return false;
                                    }
                                }
                            }
                            return x !== el;
                        });
                        if (el.checked) {
                            others.forEach(function (x) {
                                x.setAttribute("disabled", "");
                                x.classList.add('is-reset');
                            });
                        }
                        else {
                            others.forEach(function (x) {
                                x.removeAttribute("disabled");
                                x.classList.remove('is-reset');
                            });
                        }
                    });
                });
            });
        }
        core.onPageLoad = onPageLoad;
        function onFormSubmit() {
            // "blur" the active element, removing focus and hopefully preventing double enter key press
            document.activeElement.blur();
            document.getElementById("overlay").style.display = 'block';
        }
        core.onFormSubmit = onFormSubmit;
        function post() {
            // <summary>Sets the time expired flag and calls the next group function.</summary>
            $('#' + core.attributeValues.timeExpired).val('true');
            core.nextGroup(null);
        }
        core.post = post;
        function previousGroup(e) {
            // <summary>Perform ajax action to go back.</summary>
            // <param name="e">The current event.</param>
            // Clear the timeout
            if (core.id.timeoutHolder) {
                clearTimeout(core.id.timeoutHolder);
            }
            // Trigger the form post.
            var _input = $("<input>").attr("type", "hidden").attr("name", "action:Back");
            $('#surveyGroupForm').append(_input).trigger("submit");
            return false;
        }
        core.previousGroup = previousGroup;
        function timer(timerMode, delay) {
            // <summary>Sets the survey timer if enabled.</summary>
            // <param name="timerMode">The timer mode.</param>
            // <param name="delay">The timer length.</param>
            if (timerMode == 'Pause') {
                core.id.timeoutHolder = setTimeout(post, delay);
            }
        }
        core.timer = timer;
        function sfAutoComplete(e) {
            // <summary>Fires the SF auto complete logic for the selected value then loads the next page.</summary>
            // <param name="e">The current event.</param>
            var _completionVal = e.target.getAttribute("data-gss-sfauto-val");
            $("#sfAutoVal").val(_completionVal);
            $("#sfAutoSubmit").trigger("click");
        }
        core.sfAutoComplete = sfAutoComplete;
        /* Event binding */
        $(document).on('click', '[name="sfAuto"]', core.sfAutoComplete);
        $(document).on('submit', '[id="surveyGroupForm"]', core.onFormSubmit);
        $(document).ready(onPageLoad);
    })(core = Survey.core || (Survey.core = {}));
})(Survey || (Survey = {}));
//# sourceMappingURL=Survey.core.js.map